module.exports = __webpack_public_path__ + "img/Task.64b06b08.svg";